// extracted by mini-css-extract-plugin
export var hidden = "_4o-1";
export var leftPanel = "_4o-2";
export var readonlyInspector = "_4o-3";
export var rightPanel = "_4o-0";